(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    // NOTE: no "run once globally" guard here on purpose, and registration
    // is also clone-safe (see comment inside register()) so it's always
    // safe to call initAll()/register repeatedly, including on cloned
    // slider slides.

    // All rotating blocks share ONE clock (t0 below), so they switch in
    // perfect unison no matter when each block happened to register
    // (instant load, late MutationObserver clone, theme-editor re-render,
    // etc). Each block still keeps its own speed/animation settings, but
    // the active index is computed from elapsed time, not from each
    // block's own independent setInterval countdown.
    var t0 = Date.now();
    var registered = [];
    var tickHandle = null;

    function applyState(entry) {
      var elapsed = Date.now() - t0;
      var index = Math.floor(elapsed / entry.intervalMs) % entry.items.length;
      if (index === entry.activeIndex) return;
      entry.items[entry.activeIndex].classList.remove('is-active');
      entry.activeIndex = index;
      entry.items[entry.activeIndex].classList.add('is-active');
    }

    function tick() {
      registered.forEach(applyState);
    }

    function ensureTicking() {
      if (tickHandle) return;
      tickHandle = setInterval(tick, 100);
    }

    function register(el) {
      // IMPORTANT: don't gate on dataset.rotateStarted. Carousel/slider
      // libraries (Swiper, Slick, etc.) often clone slide markup for
      // infinite-loop behavior. cloneNode() copies HTML attributes
      // (including any data-rotate-started left over from the original)
      // but never copies custom JS state. Gating on the dataset flag
      // would permanently block clones from ever being registered.
      if (el._rotateEntry) return;

      var items = el.querySelectorAll('.text-block__rotate-item');
      if (items.length < 2) return;

      var speed = parseFloat(el.dataset.rotateSpeed) || 3;
      var entry = {
        el: el,
        items: items,
        intervalMs: speed * 1000,
        activeIndex: 0,
      };

      // Normalize starting state in case this element is a clone that
      // inherited is-active on a different item than index 0.
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === 0);
      });

      el._rotateEntry = entry;
      el.dataset.rotateStarted = 'true';
      registered.push(entry);

      // Snap this block to whatever index it should already be showing
      // given the shared clock, then start the shared ticker if needed.
      applyState(entry);
      ensureTicking();
    }

    function unregister(el) {
      if (!el._rotateEntry) return;
      registered = registered.filter(function (entry) {
        return entry.el !== el;
      });
      el._rotateEntry = null;
      delete el.dataset.rotateStarted;
    }

    function initAll(root) {
      (root || document)
        .querySelectorAll('[data-rotate-text]')
        .forEach(register);
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initAll();
    }

    // Re-init/teardown when blocks are added, removed, or re-rendered in the theme editor.
    document.addEventListener('shopify:block:select', function (event) {
      if (!event.target.querySelectorAll) return;
      event.target.querySelectorAll('[data-rotate-text]').forEach(register);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-rotate-text]').forEach(unregister);
    });

    // Carousel/slider libraries frequently clone slide markup AFTER initial
    // load (e.g. to build an infinite-loop track, or on first drag/swipe).
    // Watch for any such clones being inserted and register them too,
    // since they won't fire shopify:section:load and DOMContentLoaded has
    // already passed by the time they appear. Thanks to the shared clock,
    // a late-registered clone still snaps straight to the correct index.
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-rotate-text]')) {
            register(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-rotate-text]').forEach(register);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
